import { useApi } from "../../api";
import { useNotifications } from "../useNotifications";
import { useAppDispatch } from "../../store";

export const useRequestHandlers = () => {
  const { getApi } = useApi();
  const { notify } = useNotifications();
  const dispatch = useAppDispatch();
  return { getApi, notify, dispatch };
};
